import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, EffectFade } from "swiper/modules";
import banner1 from "../Images/banner1.jpeg";
import banner2 from "../Images/banner2.jpg";
import banner3 from "../Images/banner3.jpeg";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

export default function Hero() {
  const slides = [
    {
      id: 1,
      bg: banner1,
       showText: true,
      align: "left",
      title: (
        <>
          Transform Your <span className="text-blue-400">Future With</span> Expert-Led Courses
        </>
      ),
      subtitle:
        "EasyLearn Educare is a trusted educational consultancy in Kolkata, guiding students toward top MBA and professional",
      buttons: [
        { label: "Start Now", href: "#courses", primary: true },
        { label: "Study Abroad", href: "#contact", primary: false }
      ],
    },
    {
      id: 2,
      bg: banner2,
      align: "center",
      showText: false,
    //   title: (
    //     <>
    //       Study Abroad & Build Your <span className="text-blue-400">Global Career</span>
    //     </>
    //   ),
    //   subtitle:
    //     "We help students get admission to leading universities worldwide with expert guidance.",
    //   buttons: [
    //     { label: "Apply Now", href: "#apply", primary: true },
    //     { label: "Free Consultation", href: "#contact", primary: false }
    //   ],
    },
    {
      id: 3,
      bg: banner3,
      align: "right",
      showText: false,
    //   title: (
    //     <>
    //       Online Degree Programs From <span className="text-blue-400">Top Institutions</span>
    //     </>
    //   ),
    //   subtitle:
    //     "Upgrade your skills while studying from the comfort of your home with affordable courses.",
    //   buttons: [
    //     { label: "Explore Courses", href: "#explore", primary: true },
    //     { label: "Talk To Counsellor", href: "#contact", primary: false }
    //   ],
    },
  ];

  return (
    <section className="relative w-full h-[650px] overflow-hidden">

      <Swiper
        modules={[Autoplay, Pagination, EffectFade]}
        autoplay={{ delay: 3500 }}
        pagination={{ clickable: true }}
        effect="fade"
        loop
        className="absolute inset-0 w-full h-full"
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.id}>
            {/* Background */}
            <div
              className="w-full h-full bg-cover bg-center"
              style={{ backgroundImage: `url(${slide.bg})` }}
            ></div>

            {/* Dark overlay */}
            <div className="absolute inset-0 bg-black/50"></div>

            {/* Text Content */}
            <div
              className={`absolute inset-0 flex items-center px-6 sm:px-20 ${
                slide.align === "right"
                  ? "justify-end text-right"
                  : slide.align === "center"
                  ? "justify-center text-center"
                  : "justify-start text-left"
              }`}
            >
              <div
  className={`w-full h-full flex items-center justify-${slide.align}`}
>
  {slide.showText && (
    <div className="text-white max-w-2xl p-6">
      <h1 className="text-5xl font-bold leading-tight">
        {slide.title}
      </h1>

      {slide.subtitle && (
        <p className="mt-4 text-lg text-gray-300">{slide.subtitle}</p>
      )}

      <div className="mt-6 flex gap-4">
        <button className="bg-blue-600 px-5 py-3 rounded-md text-white hover:bg-blue-700 transition">
          Start Journey
        </button>
        <button className="border border-white px-5 py-3 rounded-md text-white hover:bg-gray-200 hover:text-black transition">
          Study Abroad
        </button>
      </div>
    </div>
  )}
</div>

            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}
